import React from 'react';
import { ShopOutlined } from '@ant-design/icons';

const ShopName = ({ shop = {}, hideCode = false }) => {
    const { name } = shop;
    const { code } = shop;

    return name ? (
        <span className='shop-element'>
            <ShopOutlined />
            {name}<br/>
            {!hideCode && code &&
                <small><i>{code}</i></small>
            }
        </span>
    ) : null;
}

export default ShopName;
